export default function safeDecodeURIComponent(str, fallback) {
	if (!str) {
		return fallback;
	}

	try {
		const decoded = decodeURIComponent(str);
		return decoded;
	} catch (e) {
		return fallback;
	}
}
